module.exports = __webpack_public_path__ + "static/media/more.04298951.svg";